<template>
  <v-layout v-if="wholesalerAccount?.wholesaler?.name" justify-space-between align-center>
    <span class="fixed-value">{{ wholesalerAccount?.wholesaler?.name }}</span>
    <v-btn small color="error" class="rounded-4" @click="clear">변경</v-btn>
  </v-layout>

  <ValidationProvider v-else name="공급사" rules="required" v-slot="{ errors }">
    <v-autocomplete
      v-model="value"
      outlined
      height="46"
      hide-details
      autocomplete
      return-object
      item-value="uuid"
      ref="autocomplete"
      :filter="searchfilter"
      :error="errors.length > 0"
      :items="wholesalerAccounts"
      item-text="wholesaler.name"
      :search-input.sync="inputValue"
      placeholder="공급사를 입력해주세요"
      no-data-text="검색된 공급사 및 계좌가 없습니다."
      @change="select"
      oninput="this.value = this.value.trim()"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-html="item.title"></v-list-item-title>
          <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
        </v-list-item-content>
      </template>

      <template
        v-slot:prepend-item
        v-if="(!value && inputValue) || (value && value.wholesaler.name !== inputValue)"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>찾으시는 공급사가 없나요? </v-list-item-subtitle>
            <v-btn color="primary" block @click.stop="directInput(inputValue)">
              "{{ inputValue }}"으로 신규 등록하기
            </v-btn>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>
      </template>
    </v-autocomplete>
    <v-slide-y-transition>
      <p v-if="errors.length > 0" class="guide-error">{{ errors[0] }}</p>
    </v-slide-y-transition>
  </ValidationProvider>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    wholesalerAccount: {
      type: Object,
      isRequired: false,
    },
  },
  data() {
    return {
      items: [],
      inputValue: '',
      value: null,
      wholesalerAccountsSource: null,
    }
  },
  async created() {
    await this.loadAllWholesalerAccounts()
    this.wholesalerAccountsSource = this.getAvailableWholesalerAccounts
  },

  watch: {
    wholesalerAccount(v) {
      this.value = v
    },
  },
  computed: {
    ...mapGetters('choice', ['getBank']),
    ...mapGetters('creditPay/wholesaler', ['getAvailableWholesalerAccounts']),

    wholesalerAccounts() {
      const accounts =
        this.wholesalerAccountsSource?.map((e) => {
          const bankName = this.getBank(e.bank)?.name?.replace(/[은행|증권]/g, '')
          const title = `${e.wholesaler.name}`
          const subtitle = `${bankName} ${e.accountNumber} ${e.holderName}`

          return {
            ...e,
            bankName,
            title: this.replaceMask(title, this.inputValue),
            subtitle: this.replaceMask(subtitle, this.inputValue),
            label: `${title} ${subtitle}`,
          }
        }) || []

      return [...accounts]
    },
  },
  methods: {
    ...mapActions('creditPay/wholesaler', ['loadAllWholesalerAccounts']),
    select() {
      this.$emit('update:wholesalerAccount', this.value)
    },
    clear() {
      this.$emit('update:wholesalerAccount', null)
      this.$nextTick(() => {
        this.$refs.autocomplete?.focus()
        this.$refs.autocomplete?.activateMenu()
      })
    },

    directInput(inputValue) {
      this.$emit('update:wholesalerAccount', { wholesaler: { name: inputValue } })
    },

    /**
     * autocomplete 검색 결과에서 키워드부분 마스킹 처리
     * @param {*} str
     * @param {*} keyword
     */
    replaceMask(str, keyword) {
      return str.replace(keyword, `<span class="v-list-item__mask">${keyword}</span>`)
    },

    searchfilter(item, queryText, itemText) {
      return item.label.indexOf(queryText) > -1
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control {
  > .v-input__slot {
    min-height: 46px;
  }
  .v-input__append-inner {
    margin-top: 12px;
  }
}

// ::v-deep .v-list-item__mask {
//   // background: #1baaf1 !important;
//   // color: white !important;
// }
</style>
